@let subPaymentTransactions = saleSubscriptionPaymentTransactions();
@if(subPaymentTransactions?.length) {

<table class="table table-sm table-striped align-middle mb-0 sansserif_font">
   <thead>
      <tr>
         <th class="payment-type" scope="col">Source</th>
         <th class="payment-effective" scope="col">Effective</th>
         <th class="payment-status" scope="col">Status</th>
         <th class='text-end' scope="col">Amount</th>
      </tr>
   </thead>
   <tbody>
      @for (subPaymentTransaction of subPaymentTransactions; track $any(subPaymentTransaction).id) {
      @let paymentTransaction = subPaymentTransaction.paymentTransaction;
      @let paymentTransactionInfo = paymentTransaction?.info;
      @let isRefunded = paymentTransactionInfo?.referencePaymentTransactionTypeCode === PaymentTransactionType_.Credit;
      @if(paymentTransaction?.paymentInstrument) {
      <tr>
         <td class="payment-type">
            <app-payment-instrument-display [paymentInstrument]="paymentTransaction.paymentInstrument"></app-payment-instrument-display>
         </td>
         <td style="white-space: nowrap">{{paymentTransaction.effective|date:'MM/dd/yy'}}</td>
         <td class="payment-status">
            @if (paymentTransaction.typeCode === PaymentTransactionType_.Void) {
            <span class="badge text-bg-secondary me-1">Voided</span>
            } @else if (paymentTransaction.typeCode === PaymentTransactionType_.ReturnItem) {
            <span class="badge text-bg-secondary me-1">Returned</span>
            }
            @if (!isRefunded) {
            <span [class]="paymentTransaction.statusCode ? 'text-danger' : 'text-success'">{{paymentTransaction.responseMessage}}</span>
            }
            @if (isRefunded) {
            <span class="badge text-bg-danger">Refunded</span>
            }
            @let reversal = paymentTransaction.paymentTransactionReversalOriginalPaymentTransaction;
            @if (reversal &&
            (reversal.statusCode === PaymentTransactionReversalStatus_.Pending ||
            reversal.statusCode === PaymentTransactionReversalStatus_.Processing)) {
            <span class="badge text-bg-warning ms-2">Reversal pending settlement</span>
            } @else if (reversal && reversal.statusCode === PaymentTransactionReversalStatus_.Failed) {
            <span class="badge text-bg-danger ms-2">Reversal failed</span>
            }
            @if (canReverse(subPaymentTransaction)) {
            @if (pendingRefund() === subPaymentTransaction) {
            <div class="alert alert-warning d-inline-flex align-items-center gap-2 mb-0 ms-2 py-1 px-2">
               <span class="small">Reverse {{paymentTransaction.amount|currency}}?</span>
               <button type="button"
                       class="btn btn-sm btn-danger py-0"
                       [disabled]="isRefunding()"
                       (click)="confirmRefund(subPaymentTransaction)">
                  {{ isRefunding() ? 'Submitting…' : 'Confirm' }}
               </button>
               <button type="button"
                       class="btn btn-sm btn-outline-secondary py-0"
                       [disabled]="isRefunding()"
                       (click)="cancelRefund()">
                  Cancel
               </button>
            </div>
            } @else {
            <button type="button"
                    class="btn btn-sm btn-outline-danger ms-2 py-0"
                    (click)="requestRefund(subPaymentTransaction)">
               Reverse
            </button>
            }
            }
         </td>
         <td class="text-end"
             [class.text-danger]="isRefunded"
             [class.text-decoration-line-through]="isRefunded">
            {{paymentTransaction.amount|currency}}
         </td>
      </tr>
      }
      }
   </tbody>
</table>

}
